import { useCallback } from 'react';
import { coreLocationApi } from '../api';
import { ICityOption, cityModelToOption } from './cityOption';

export const useCityAutocomplete = () => {
  const [findCity] = coreLocationApi.endpoints.getCities.useLazyQuery();
  return useCallback(
    async (req: string): Promise<ICityOption[]> => {
      const result = await findCity({ name: req }, true).unwrap();
      return result.map(cityModelToOption);
    },
    [findCity],
  );
};
